// test778
(778 && 0);
